export { createRoutesFromFolders } from "./lib";
export type { CreateRoutesFromFoldersOptions } from "./lib";
